import { AxiosResponse } from 'axios'
import { UpdateBody } from 'types/common'
import { api } from 'API'
import { ITextContent } from 'interfaces/textContent'

export async function updateTextContentById(id: string, updateBody: UpdateBody<ITextContent>): Promise<void> {
  await api.patch(`/text-contents/${id}`, updateBody)
}

export async function deleteTextContentById(id: string): Promise<void> {
  await api.delete(`/text-contents/${id}`)
}

export async function createTextContent(updateBody: Partial<ITextContent>): Promise<ITextContent> {
  const response: AxiosResponse = await api.post(`/text-contents`, updateBody)
  return response?.data
}

/** What the batch-position route reads: the row and its new slot. */
export interface ITextContentPositionUpdate {
  id: string
  position: number
}

// One request for a whole reorder. Per-row PATCHes cost a round trip and an
// edit-lock check each, which is what made reordering a long Drill drag.
export async function updateTextContentBatch(updateBody: ITextContentPositionUpdate[]): Promise<void> {
  await api.patch(`/text-contents/position/batch`, updateBody)
}

export async function upsertMedia(id: string, mediaIds: number[]): Promise<void> {
  await api.patch(`/text-contents/${id}/upsert-media`, mediaIds)
}
